import type { Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null> | null = null;

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  function getStripe(): Promise<Stripe | null> {
    if (stripePromise) return stripePromise;

    const key = config.public.stripePublishableKey;
    if (!key) {
      stripePromise = Promise.resolve(null);
      return stripePromise;
    }

    stripePromise = import('@stripe/stripe-js').then(({ loadStripe }) =>
      loadStripe(key),
    );
    return stripePromise;
  }

  return {
    provide: {
      stripe: getStripe,
    },
  };
});

declare module '#app' {
  interface NuxtApp {
    $stripe: () => Promise<Stripe | null>;
  }
}
